export type AIContextSchema = { [key: string]: any }

export type AIContextSchemaPayload = {
  aiFeatureId: string
  schema: AIContextSchema
}

export type AIResultContext = {
  id: string
  aiResult: any
}

export interface AIContextState {
  selectedResults: AIResultContext[]
  aiFeatureIdInEdit: null | string
  aiContextSchemas: { [key: string]: AIContextSchema }
}

export const initialAIContextState: AIContextState = {
  selectedResults: [],
  aiFeatureIdInEdit: null,
  aiContextSchemas: {},
}
